import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { OwnershipTransferAction } from "./actions/ownership-transfer/OwnershipTransferAction";

interface IDangerZoneSection {
    onOwnerChange: (ownerId: number) => void;
}

export const DangerZoneSection = ({ onOwnerChange }: IDangerZoneSection) => (
    <Flex
        flexDirection="column"
        gap="12px"
    >
        <Flex
            alignItems="center"
            gap="4px"
        >
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("llmTracker.campaignQuery.edit.danger-zone.title")}
            </Text>
        </Flex>
        <OwnershipTransferAction onOwnerChange={onOwnerChange} />
    </Flex>
);
